import React, { useEffect, useState } from "react";
import { AntdButton, Inner, Section } from "./styles.js";
import { Typo } from "../../../../../../components/layout/theme/index.js";
import { Form, Select, Switch } from "antd";
import { useReport } from "../../../../../../contexts/ReportContext.js";
import { get_car_type_of_use } from "../../../../../../api/endpoints/cars.js";
import { useMatomo } from "@datapunt/matomo-tracker-react";

const CarSpecialFeatures = ({ nextSubStep, nextMainStep, isMobile }) => {
	const { reportForm, updateReportForm } = useReport();
	const [form] = Form.useForm();
	const [typeOfUses, setTypeOfUses] = useState(null);
	const [selectedTypeOfUses, setSelectedTypeOfUses] = useState(null);
	const [initialValues, setInitialValues] = useState(null);
	const { trackEvent } = useMatomo();

	// Verificar si el año del vehículo es el año actual
	const isCurrentYear = reportForm?.carData?.year === new Date().getFullYear();

	useEffect(() => {
		const fetch_initial_values = () => {
			const values = {
				hasGNC: reportForm?.carSpecialFeatures?.hasGNC,
				isZeroKm: reportForm?.carSpecialFeatures?.isZeroKm,
				hasGarage: reportForm?.carSpecialFeatures?.hasGarage,
				hasGPS: reportForm?.carSpecialFeatures?.hasGPS,
			};

			setSelectedTypeOfUses(reportForm?.carSpecialFeatures?.typeOfUseId);

			setInitialValues(values);
		};
		fetch_initial_values();
	}, [reportForm]);

	useEffect(() => {
		const fetch_type_of_uses = () => {
			const res = get_car_type_of_use();
			setTypeOfUses(
				res?.map((b) => ({
					value: b.id,
					label: b.name,
				}))
			);
			
			// Si no hay un tipo de uso seleccionado previamente, establecer "Particular" (id: 1) por defecto
			if (!reportForm?.carSpecialFeatures?.typeOfUseId) {
				setSelectedTypeOfUses(1);
			}
		};
		fetch_type_of_uses();
	}, [reportForm?.carSpecialFeatures?.typeOfUseId]);

	useEffect(() => {
		if (initialValues) {
			form.setFieldsValue(initialValues);
		}
	}, [initialValues, form]);

	const handleNextStep = (values) => {
		const updatedValues = {
			hasGNC: values?.hasGNC,
			// Solo permitir isZeroKm si el año es el actual
			isZeroKm: isCurrentYear ? values?.isZeroKm : false,
			hasGarage: values?.hasGarage,
			hasGPS: values?.hasGPS,
			typeOfUseId: selectedTypeOfUses,
		};
		trackEvent({
			category: "button-click",
			action: "next-button",
			name: `step1.infoVehicle-(3)characteristics::${JSON.stringify(
				updatedValues
			)}`,
		});

		updateReportForm(updatedValues);

		nextMainStep(1);
	};

	return (
		<Form
			form={form}
			name="car-special-features-form"
			initialValues={initialValues}
			onFinish={handleNextStep}
		>
			<Inner>
				<Typo level={isMobile ? 3 : 2} style={{ textAlign: "center" }}>
					¿Tu auto tiene alguna de estas características especiales?
				</Typo>
				<Section isMobile={isMobile}>
					<Section style={{ gap: 10 }}>
						<Typo>GNC</Typo>
						<Form.Item name="hasGNC" style={{ marginBottom: 0 }}>
							<Switch></Switch>
						</Form.Item>
					</Section>
					{isCurrentYear && (
						<Section style={{ gap: 10 }}>
							<Typo>0 Km</Typo>
							<Form.Item name="isZeroKm" style={{ marginBottom: 0 }}>
								<Switch></Switch>
							</Form.Item>
						</Section>
					)}
					<Section style={{ gap: 10 }}>
						<Typo>Garage</Typo>
						<Form.Item name="hasGarage" style={{ marginBottom: 0 }}>
							<Switch></Switch>
						</Form.Item>
					</Section>
					<Section style={{ gap: 10 }}>
						<Typo>Localizador</Typo>
						<Form.Item name="hasGPS" style={{ marginBottom: 0 }}>
							<Switch></Switch>
						</Form.Item>
					</Section>
				</Section>
				<Section>
					<Select
						showSearch
						placeholder="Tipo de uso"
						optionFilterProp="children"
						value={selectedTypeOfUses}
						onChange={(e) => setSelectedTypeOfUses(e)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={typeOfUses}
						style={{ width: 250 }}
					/>
				</Section>
				<Section style={{ maxWidth: "250px" }}>
					<AntdButton key="PrevStep1CarLocation" onClick={() => nextSubStep(2)}>
						<Typo level={5}>Anterior</Typo>
					</AntdButton>
					<AntdButton
						key="NextStep1CarSpecialFeatures"
						type="primary"
						htmlType="submit"
					>
						<Typo level={5} type="white">
							Siguiente
						</Typo>
					</AntdButton>
				</Section>
			</Inner>
		</Form>
	);
};

export default CarSpecialFeatures;
